import { useNavigate } from "react-router-dom"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const Container = styled.div<{ $clickable: boolean }>`
  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: var(--accent);
    }
  `}
`

interface CustomerAddressProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerAddress = ({ cell }: CustomerAddressProps) => {
  const navigate = useNavigate()
  const address = cell.getValue().value as string
  const customerId: number | null = cell.row.original.rowSettings.item.client_id
  const deviceSN: string | null = cell.row.original.rowSettings.item.sn || null

  const isClickable = Boolean(customerId)

  const handleCustomerClick = () => {
    if (!customerId) return

    const queryParams = new URLSearchParams({ openSidebar: "true" })
    if (deviceSN) {
      queryParams.set("selectedDevice", deviceSN)
    }
    navigate(`/customers/${customerId}/details?${queryParams.toString()}`)
  }

  return (
    <Container $clickable={isClickable} onClickCapture={handleCustomerClick}>
      {address || ""}
    </Container>
  )
}
